export default __webpack_public_path__ + "static/media/gradient-tall.8229a571.png";